import type { ComponentProps } from 'react';
import { Link } from 'react-router';
import { buttonClass, type ButtonSize, type ButtonVariant } from './classes';

type StyleProps = { variant?: ButtonVariant; size?: ButtonSize };

export const Button = ({
  variant,
  size,
  className,
  ...buttonProps
}: ComponentProps<'button'> & StyleProps) => (
  <button className={buttonClass(variant, size, className)} {...buttonProps} />
);

export const ButtonLink = ({
  variant,
  size,
  className,
  ...linkProps
}: ComponentProps<typeof Link> & StyleProps) => (
  <Link className={buttonClass(variant, size, className)} {...linkProps} />
);
